/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-window': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M238 216h-4V62a6 6 0 00-6-6H72a6 6 0 00-6 6v154h-4a6 6 0 00-6 6v16a6 6 0 006 6h176a6 6 0 006-6v-16a6 6 0 00-6-6zM74 64h152v152H74zm162 172H64v-12h172z"/><path pid="1" d="M218 68H82a4 4 0 00-4 4v136a4 4 0 004 4h136a4 4 0 004-4V72a4 4 0 00-4-4zm0 70h-66V72h66zm-70-66v66H82V72zm-66 70h66v66H82zm70 66v-66h66v66z"/>'
  }
})
